import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    Industry
} from '../../models/models';

@Component({
    selector: 'industry-form',
    templateUrl: './industry-form.component.html',
    standalone: false
})
export class IndustryForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: Industry = {} as Industry;

    constructor(private crmService: CRMService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getTableItem() {
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        if (this.tableID > 0) {
            this.crmService.getIndustryByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                    this.tableItem.lastModifiedEmployeeId = employeeID;
                }
            });
        }
        else {
            this.tableItem = {
                industryId: 0,
                abbreviation: "",
                description: "",
                createDate: new Date(),
                createEmployeeId: employeeID
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.crmService.saveIndustry(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as Industry;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}